import { createFileRoute } from "@tanstack/react-router";
import { Install } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";
import { RelatedResources } from "@/components/seo/RelatedResources";

export const Route = createFileRoute("/install")({
  head: () => seoHead(SEO.install),
  component: () => (
    <>
      <Install />
      <RelatedResources
        title="Not ready to install yet?"
        intro={<p>The LeadXkids app installs straight from your browser, with no app store needed, and takes very little space on your phone. It is the same site as leadxkids.com, so your account, courses and progress stay in sync. You can use everything below in the browser as well.</p>}
        items={[
          { href: "/", label: "LeadXkids home", note: "How the life skills courses work for children aged 8-14." },
          { href: "/courses", label: "All courses", note: "Confidence, communication, focus, resilience and more." },
          { href: "/tools", label: "Free parent tools", note: "Quick checks and printable planners." },
          { href: "/blog", label: "Parent guides", note: "Practical, research-informed articles for parents." },
        ]}
      />
    </>
  ),
});
